import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NavController,
  NavParams,
  ModalController,
  LoadingController,
  ToastController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { FormAtividadeNotaComponent } from 'src/app/components/form-atividade-nota/form-atividade-nota';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { EventoProvider } from 'src/app/services/evento/evento';

declare var instituicaoConstants: { IS_PWA: boolean };

@Component({
  selector: 'app-encontro-nota-pessoa',
  templateUrl: './encontro-nota-pessoa.page.html',
  styleUrls: ['./encontro-nota-pessoa.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    FormAtividadeNotaComponent,
    NomenclaturaPipe,
    DateFormatPipe,
    LoadingSpinnerComponent
  ],
})
export class EncontroNotaPessoaPage implements OnInit {
  isPWA = false;
  atividades: any = [];
  participante: any;
  idEncontro: any;
  encontro: any;
  loaded = false

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public eventoProvider: EventoProvider
  ) {
    this.isPWA = instituicaoConstants.IS_PWA;
    this.participante = this.navParams.get('participante');
    this.idEncontro = this.navParams.get('idEncontro');
    this.encontro = this.navParams.get('encontro')
    this.eventoProvider
      .getNotasParticipante(this.participante.idPessoa, this.idEncontro)
      .subscribe((data) => {
        this.atividades = data;
      });
      setTimeout(() => {
        this.loaded = true;
      }, 1000);
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  salvarNotas() {
    var loader = this.loadingController.create({
      message: this.translate.instant('Salvando'),
    });

    this.eventoProvider
      .salvarNotasParticipante(
        this.idEncontro,
        this.participante.idPessoa,
        this.atividades
      )
      .subscribe(async (data) => {
        this.modalCtrl.dismiss();

        const toast = await this.toastCtrl.create({
          message: this.translate.instant('Notas salvas com sucesso'),
          duration: 3000,
        });

        toast.present();
      });
  }
}
